export default __webpack_public_path__ + "media/zurb/img/ecommerce/columbia-7f1272ea85d284cec154180e69f399ed.png";